import React, { useState, useEffect } from "react";
import TextInfo, {
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_COLOR,
  TEXT_DECORATION,
} from "@gc-npm/components.text";
import Icon from "@gc-npm/components.icon-glyph";
import CustomLink from "@gc-npm/components.custom-link";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import {
  generateQueryString,
} from "@/utils/normalizers/product";
import { createBrowserHistory } from "history";
import styles from "./style";
import { getFullUrl } from "@/utils/htmlUtils";

const ButtonFilter = () => {
  const router = useRouter();
  const { query } = router;
  const {
    filters,
    selectedFilters,
    sort,
    searcherQuery,
    id: idRoute,
    filtersApplied,
  } = useSelector((state) => state.devicesList);
  useSelector((state) => state.pageInfo);
  const [buttonSelected, setButtonSelected] = useState([]);
  const [customTagsButtonSelected, setCustomTagsButtonSelected] = useState([]);
  const [tagsButtonSelected, setTagsButtonSelected] = useState([]);
  const history = typeof window === "undefined" ? "" : createBrowserHistory();
  const ModalOpen =
    history.location && history.location.hash === "#FiltersModal";

  useEffect(() => {
    let value = [];
    if (selectedFilters.tags !== undefined) {
      value.push(...selectedFilters.tags);
      setTagsButtonSelected(selectedFilters.tags);
    } else {
      setTagsButtonSelected([]);
    }
    if (selectedFilters.customTags !== undefined) {
      value.push(...selectedFilters.customTags)
      setCustomTagsButtonSelected(selectedFilters.customTags);
    } else {
      setCustomTagsButtonSelected([]);
    }
    setButtonSelected(value);
  }, [selectedFilters]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const handleChange = ({ id, type, queryAction }) => {
    let url;
    const selectedFiltersNew = JSON.parse(JSON.stringify(selectedFilters));
    //selectedFiltersNew.resultsFrom = 0;
    selectedFiltersNew.id = idRoute;
    if (searcherQuery) selectedFiltersNew.query = searcherQuery;
    if (buttonSelected.includes(id)) {
      //El filtro elegido ya está seleccionado
      //Filtro ficticio que no procesa PAC
      if (type === "customTag") {
        selectedFiltersNew.customTags = customTagsButtonSelected.filter(
          (selectedId) => selectedId !== id
        );
      } else {
        selectedFiltersNew.tags = tagsButtonSelected.filter(
          (selectedId) => selectedId !== id
        );
      }
      url = getFullUrl(`/${idRoute}?sort=${sort}&${generateQueryString(selectedFiltersNew)
        }`, query, true);
      router.push(`${url}${ModalOpen ? "#FiltersModal" : ""}`, undefined, { shallow: true });
    } else {
      //El filtro elegido no está seleccionado
      //Filtro ficticio que no procesa PAC
      if (type === "customTag") {
        selectedFiltersNew.customTags = [...customTagsButtonSelected, id];
        sessionStorage.setItem("customTags", selectedFiltersNew.customTags);
      } else {
        selectedFiltersNew.tags = [...tagsButtonSelected, id];
      }
      url = getFullUrl(`/${idRoute}?sort=${sort}&${generateQueryString(selectedFiltersNew)}`, query);
      router.push(`${url}${ModalOpen ? "#FiltersModal" : ""}`, undefined, { shallow: true });
    }
  };

  const handleChangeFilterSelected = (name, value, type) => {
    let selectedFiltersNew = { ...selectedFilters };
    //selectedFiltersNew.resultsFrom = 0;

    if (Array.isArray(selectedFiltersNew[name])) {
      selectedFiltersNew[name] = selectedFiltersNew[name].filter(
        (selectedValue) => selectedValue !== value
      );
    } else {
      if (type === "RANGE") {
        selectedFiltersNew = Object.keys(selectedFiltersNew).reduce(
          (result, key) => {
            if (
              key !== `min${capitalizeFirstLetter(name)}` &&
              key !== `max${capitalizeFirstLetter(name)}`
            ) {
              result[key] = selectedFiltersNew[key];
            }
            return result;
          },
          {}
        );
      }
    }
    if (searcherQuery) {
      selectedFiltersNew.query = searcherQuery;
    }
    const url = getFullUrl(`/${idRoute}?sort=${sort}&${generateQueryString(selectedFiltersNew)}`, query);
    selectedFiltersNew.id = idRoute;
    router.push(`${url}${ModalOpen ? "#FiltersModal" : ""}`, undefined, { shallow: true });
  };

  const clearFilters = () => {
    const url = getFullUrl(`/${idRoute}`, query, true);
    router.push(url, undefined, { shallow: true });
  };

  const handleChangeFilterQuery = () => {
    const selectedFiltersNew = { ...selectedFilters };
    selectedFiltersNew.query = "";
    selectedFiltersNew.id = idRoute;
    const url = getFullUrl(`/${idRoute}?sort=${sort}&${generateQueryString(selectedFiltersNew)}`, query);
    router.push(`${url}${ModalOpen ? "#FiltersModal" : ""}`, undefined, { shallow: true });
  };

  const isValidColor = (color) => /^#([0-9A-Fa-f]{3}){1,2}$/.test(color);

  const isColorDark = (color) => {
    if (color === undefined || !isValidColor(color)) return false;

    const hexColor = color.replace("#", "");
    const red = parseInt(hexColor.substr(0, 2), 16);
    const green = parseInt(hexColor.substr(2, 2), 16);
    const blue = parseInt(hexColor.substr(4, 2), 16);
    const brightness = (red * 299 + green * 587 + blue * 114) / 1000;
    return brightness < 128;
  };

  {/* Lógica mantenida para las customTags seleccionadas. Las tags ya no lo consumen */ }
  let filterOffers = filters.filter((filtered) => (filtered.id === "customTags")).flatMap(filteredOffer => (
    (filteredOffer && filteredOffer.values) !== undefined
      ? filteredOffer.values
      : []
  ));

  let buttonfilters = [];

  const addedKeys = new Set();

  //Logica endiablada que recupera el filtro seleccionado para pintarlo como pill
  Object.entries(selectedFilters)
    .forEach((key) => {
      const newKey = key[0].toLowerCase().replace("min", "").replace("max", "");
      const matchingFilter = filters.find((item) => item.id === newKey);
      if (matchingFilter && !addedKeys.has(newKey)) {
        let valueToShow = "";

        if (matchingFilter.type === "RANGE") {
          let value = key[1];
          valueToShow = `${matchingFilter.name.split(" ")[0]}: ${selectedFilters[`min${capitalizeFirstLetter(matchingFilter.id)}`]
            }${matchingFilter.unit} - ${selectedFilters[`max${capitalizeFirstLetter(matchingFilter.id)}`]
            }${matchingFilter.unit}`;
          let item = {
            id: matchingFilter.id,
            type: matchingFilter.type,
            unit: matchingFilter.unit,
            value,
            valueToShow,
          };
          addedKeys.add(newKey);
          buttonfilters.push(item);
        } else {
          key[1].map((value) => {
            const valueToShow = matchingFilter
              ? `${matchingFilter.values.find((val) => val.id === value) !==
                undefined
                ? matchingFilter.values.find((val) => val.id === value).name
                : value
              }${matchingFilter.unit}`
              : `${value}${matchingFilter.unit}`;
            const item = {
              id: matchingFilter.id,
              type: matchingFilter.type,
              unit: matchingFilter.unit,
              value,
              valueToShow,
            };
            buttonfilters.push(item);
          });
        }
      }
    });
  // para ordenar los range primero
  buttonfilters.sort((a, b) => {
    if (a.type > b.type) {
      return -1;
    }
    if (a.type < b.type) {
      return 1;
    }
    return 0;
  });

  return (
    <>
      <div className="inner-wrapper" role="group" aria-label="Filtros disponibles">
        {searcherQuery !== "" && searcherQuery !== undefined && (
          <div className="ButtonContainer">
            <button
              className="ButtonChecked searcher-query"
              type="button"
              onClick={() => handleChangeFilterQuery()}
              aria-pressed="true"
              aria-label={`Eliminar filtro ${searcherQuery}`}
            >
              <TextInfo
                text={`${searcherQuery}`}
                size={TEXT_SIZE.TEXT_PRESET_02}
                color={TEXT_COLOR.BLUE_HIGH}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />{" "}
              <Icon
                className="close-icon"
                id="cerrar-l"
                height={10}
                color={TEXT_COLOR.MOVISTAR_BLUE}
              />
            </button>
          </div>
        )}

        {buttonfilters.map((data, index) => (
          <div key={`${data.id}-${index}`} className="ButtonContainer">
            <button
              key={`${data.id}-${index}`}
              className="ButtonChecked"
              type="button"
              onClick={() =>
                handleChangeFilterSelected(data.id, data.value, data.type)
              }
              aria-pressed="true"
              aria-label={`Eliminar filtro ${data.valueToShow}`}
            >
              <TextInfo
                text={`${data.valueToShow}`}
                size={TEXT_SIZE.TEXT_PRESET_02}
                color={TEXT_COLOR.BLUE_HIGH}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />{" "}
              <Icon
                id="cerrar-l"
                className="close-icon"
                height={10}
                color={TEXT_COLOR.MOVISTAR_BLUE} />
            </button>
          </div>
        ))}

        {/* Lógica mantenida para las customTags seleccionadas. Las tags ya no lo consumen */}
        {filterOffers &&
          filterOffers
            .filter((item) => buttonSelected.includes(item.id || item.name))
            .map((item) => (
              <div key={item.id} className="ButtonContainer">
                <button
                  type="button"
                  style={{
                    background: item.color,
                  }}
                  className={
                    buttonSelected.includes(item.id || item.name) ? "ButtonChecked" : ""
                  }
                  onClick={() => handleChange(item)}
                  aria-pressed={buttonSelected.includes(item.id || item.name)}
                  aria-label={`${item.name}, ${buttonSelected.includes(item.id || item.name) ? 'eliminar' : "añadir"} filtro`}
                >
                  <TextInfo
                    text={`${item.name}`}
                    size={TEXT_SIZE.TEXT_PRESET_02}
                    color={
                      buttonSelected.includes(item.id || item.name)
                        ? TEXT_COLOR.BLUE_HIGH
                        : isColorDark(item.color)
                          ? TEXT_COLOR.WHITE
                          : TEXT_COLOR.GREY_700
                    }
                    fontType={TEXT_FONT_WEIGHT.REGULAR}
                  />
                  {buttonSelected.includes(item.id || item.name) && (
                    <Icon
                      id="cerrar-l"
                      className="close-icon"
                      height={10}
                      color={
                        buttonSelected.includes(item.id || item.name)
                          ? TEXT_COLOR.BLUE_HIGH
                          : isColorDark(item.color)
                            ? TEXT_COLOR.WHITE
                            : TEXT_COLOR.GREY_700
                      }
                    />
                  )}
                </button>
              </div>
            ))}

        {filtersApplied > 0 && (
          <div className="clear-filters-mobile">
            <CustomLink
              onClick={clearFilters}
              taggingInfo={{
                componentName: "filters",
                componentVariation: "all",
                componentContent: "Borrar filtros",
                componentPerso: "",
                componentProduct: "",
              }}
              className="ButtonClearFilters"
            >
              <TextInfo
                aria-label={`Borrar filtros. ${filtersApplied} filtros seleccionados`}
                text="Borrar filtros"
                size={TEXT_SIZE.TEXT_PRESET_02}
                color={TEXT_COLOR.MOVISTAR_BLUE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
                decoration={TEXT_DECORATION.UNDERLINE}
              />
            </CustomLink>
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ButtonFilter;
